const EditExam = resolve =>require(['@/components/admin/EditExam.vue'], resolve)

export default {
  path: '/editExam',
  component: EditExam,
  meta: {
    title: '安排测评',
    path:'/editExam'
  },
}




// WEBPACK FOOTER //
// ./src/router/admin/editExam.js